import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {useDispatch} from "react-redux";
import {
    CreateCancelButtons,
    InputMain,
    NumericFormatCustom,
    YearCalendar,
} from "components";
import {FindError, FindLoad, FindSuccess, Notify, useModal} from "utils";
import {vehiclesActions, httpRequestsOnSuccessActions, httpRequestsOnErrorsActions} from "store";
import {Svg} from "assets";
import moment from "moment";

export const AddVehicle = ({info, afterSuccess}) => {
    const dispatch = useDispatch();
    const {handleSubmit, control, reset} = useForm();
    const {close} = useModal();
    const ACTION_TYPE = info ? "EDIT_VEHICLE" : "ADD_VEHICLE";
    const loading = FindLoad(ACTION_TYPE);
    const success = FindSuccess(ACTION_TYPE);
    const beckError = FindError(ACTION_TYPE);

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            afterSuccess();
            close();
        }
    }, [success]);

    useEffect(() => {
        if (beckError?.error === 'Vehicle with this Unit Number already exists') {
            Notify(beckError?.error, 'error');
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        }
    }, [beckError]);

    useEffect(() => {
        if (info) {
            const params = {
                ...info,
            };
            if (info?.year) params.year = moment(info?.year).format("YYYY");

            reset({
                ...params,
            });
        }
    }, [info]);

    const onSubmit = (data) => {
        const params = {
            ...data,
        };

        data?.year
            ? (params.year = moment(data?.year).format("YYYY"))
            : delete params.year;

        if (info) {
            dispatch(vehiclesActions.editVehicle(info?.id, params));
        } else {
            dispatch(vehiclesActions.addVehicle(params));
        }
    };

    return (
        <form
            className="add-vehicle-modal-wrapper"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="modal-header-main">
                <h3 className="modal-header-title">{info ? "Edit" : "Add"} Vehicle</h3>

                <button className="modal-close-btn-main" type="button" onClick={close}>
                    <Svg.CloseSvg/>
                </button>
            </div>

            <div className="modal-body-main">
                <InputMain
                    name="make"
                    placeholder="Ex. Ford"
                    control={control}
                    labelHeader="Make"
                    rules={{
                        required: "Make is required",
                    }}
                />

                <div className='flex-gap-16'>
                    <InputMain
                        name="modelName"
                        placeholder="Ex. Transit"
                        control={control}
                        labelHeader="Model"
                    />

                    <InputMain
                        name="unitNumber"
                        placeholder="Ex. 5"
                        control={control}
                        labelHeader="Unit"
                        rules={{
                            required: "Unit is required",
                        }}
                    />
                </div>

                <div className="flex-gap-16">
                    <YearCalendar
                        name="year"
                        labelHeader="Year"
                        placeholder="yyyy"
                        control={control}
                    />

                    <InputMain
                        name="license"
                        placeholder="Ex. ABC12345"
                        control={control}
                        labelHeader="License Plate"
                    />
                </div>

                <InputMain
                    name="vin"
                    placeholder="Ex. 1HGCM82633A123456"
                    control={control}
                    labelHeader="VIN"
                />

                <InputMain
                    name="type"
                    placeholder="Ex. SUV"
                    control={control}
                    labelHeader="Type"
                />

                <div className="flex-gap-16">
                    <InputMain
                        name="color"
                        placeholder="Ex. Blue"
                        control={control}
                        labelHeader="Color"
                    />

                    <NumericFormatCustom
                        name="seats"
                        label="Seats"
                        placeholder="0"
                        decimalScale={0}
                        control={control}
                    />
                </div>
            </div>

            <CreateCancelButtons
                createText={info ? "Save" : "Add"}
                loading={!!loading?.length}
            />
        </form>
    );
};
